module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"course":"Kurs","journey":"Reise","step":"Steg","journeyQuiz":"reisequiz"},"en":{"course":"Course","journey":"Journey","step":"Step","journeyQuiz":"journey quiz"}}')
  delete Component.options._Ctor
}
